import { isNil } from "es-toolkit";
import { Requests } from "../common/request.common";
import { DeviceResponseTypes } from "../common/response.common";
import { get, post, postEmpty } from "./common";

export const device = {
    record(data: typeof Requests.Device.Record.Input) {
        return post<typeof data, DeviceResponseTypes.Record>("/device/record", data);
    },
    create(data: typeof Requests.Device.Create.Input) {
        return post<typeof data>("/device/create", data);
    },
    info(id: string) {
        return get<DeviceResponseTypes.Info>(`/device/info/${id}`);
    },
    obtain(id: string) {
        return get<DeviceResponseTypes.Obtain>(`/device/obtain/${id}`);
    },
    restart(id: string) {
        return postEmpty<DeviceResponseTypes.RunCommand>(`/device/restart/${id}`);
    },
    delete(id: string) {
        return postEmpty(`/device/delete/${id}`);
    },
    groupRecord(id: string) {
        return (data: typeof Requests.Device.GroupRecord.Input) =>
            post<typeof data, DeviceResponseTypes.GroupRecord>(`/device/group-record/${id}`, data);
    },
    groupAdd(id: string, data: typeof Requests.Device.GroupAdd.Input) {
        return post<typeof data, DeviceResponseTypes.RunCommand>(`/device/group-add/${id}`, data);
    },
    groupDelete(id: string, data: typeof Requests.Device.GroupDelete.Input) {
        return post<typeof data, DeviceResponseTypes.RunCommand>(
            `/device/group-delete/${id}`,
            data,
        );
    },
    userDelete(id: string, data: typeof Requests.Device.UserDelete.Input) {
        return post<typeof data, DeviceResponseTypes.RunCommand>(`/device/user-delete/${id}`, data);
    },
    optionAll: async () => {
        return (await get<DeviceResponseTypes.OptionAll>("/device/option/all").execute()) ?? [];
    },
    optionByUser: async (userAttendanceId: string, status?: string | undefined) => {
        if (isNil(status)) {
            return (
                (await get<DeviceResponseTypes.OptionByUser>(
                    `/device/option/by-user/${userAttendanceId}`,
                ).execute()) ?? []
            );
        }

        return (
            (await get<DeviceResponseTypes.OptionByUser>(
                `/device/option/by-user/${userAttendanceId}/${status}`,
            ).execute()) ?? []
        );
    },
    waitCommand: (data: typeof Requests.Device.WaitCommand.Input) => {
        return post<typeof data>("/device/wait-command", data);
    },
};
